<template>
  <div class="nexultra-campaign">
    <div class="mobile-image-container lt-960">
      <img
        class="nexultra-campaign__img nexultra-campaign__img--mobile"
        src="@/assets/images/marketing-campaigns/nexultraLHorizontal.jpg"
        alt=""
      />
      <div
        class="mobile-image-container__label content__label u-typography-helvetica u-text u-text--link u-text--s"
      >
        {{ $t('nexultraMarketingPopup.label') }}
      </div>
    </div>

    <img
      class="nexultra-campaign__img nexultra-campaign__img--desktop gte-960"
      src="@/assets/images/marketing-campaigns/nexultraLVertical.jpg"
      alt=""
    />

    <div class="nexultra-campaign__content content">
      <div
        class="nexultra-campaign__label content__label u-typography-helvetica u-text u-text--link u-text--s gte-960"
      >
        {{ $t('nexultraMarketingPopup.label') }}
      </div>

      <div class="content__title u-typography-helvetica u-text u-text--l">
        {{ $t('nexultraMarketingPopup.title') }}
      </div>
      <div class="content__message u-typography-helvetica u-text u-text--s">
        {{ message }}
      </div>

      <u-button v-modal-submit class="content__button">{{
        $t('nexultraMarketingPopup.button')
      }}</u-button>
    </div>
  </div>
</template>

<script>
import { UButton } from 'universkin-shared';

import { priceFormatterMixin } from '@/mixins/priceFormatterMixin';

export default {
  name: 'NexultraLMarketingCampaign',
  components: { UButton },
  mixins: [priceFormatterMixin],
  props: {
    thresholdAmount: {
      type: Object,
      required: true
    },
    unitPrice: {
      type: Object,
      required: true
    }
  },
  computed: {
    message() {
      const thresholdAmount = this.formatPrice(this.thresholdAmount, { fractionalDigits: 0 });
      const unitPrice = this.formatPrice(this.unitPrice);

      return this.$t('nexultraMarketingPopup.message', { thresholdAmount, unitPrice });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/colors.scss';

.nexultra-campaign {
  border-radius: 10px;
  overflow: hidden;
  background-color: white;
  width: 343px;
  max-width: 100%;

  &__img {
    width: 100%;
    object-fit: fill;
  }
}

.mobile-image-container {
  position: relative;

  &__label {
    position: absolute;
    bottom: 16px;
    left: 50%;
    transform: translateX(-50%);
  }
}

.content {
  padding: 16px;

  &__label {
    background-color: var(--u-color-grey-900);
    padding: 8px 10px;
    color: white;
    width: calc(100% - 32px);
    text-align: center;
    border-radius: 3px;
  }

  &__title {
    margin-bottom: 8px;
    color: $tuatara-color;
  }

  &__message {
    margin-bottom: 24px;
    color: var(--u-color-grey-600);
  }

  &__button {
    width: 100%;
  }
}

@media (min-width: 960px) {
  .nexultra-campaign {
    display: flex;
    width: 726px;

    &__img {
      width: 35%;
    }

    &__label {
      position: static;
      transform: none;
    }
  }

  .content {
    padding: 40px;

    &__label {
      margin-top: 34px;
    }

    &__title {
      margin-top: 24px;
    }

    &__button {
      width: unset;
    }
  }
}
</style>
